export const FeatureKeys = {
  isExampleFlag: 'example-flag',
  bbogDiscoverExperiment: 'bb.og.discover',
  useExperimentApiRecommendations: 'use-experiment-api-recommendations',
  isPrDependenciesEnabled: 'pr-dependencies',
  isPrReviewGroupsEnabled: 'pr-review-groups',
  sumCreateWorkspacePreChangeEnabled:
    'ADMINX-1261-workspaces-list-sum-pre-change',
  customMergeChecksActivated: 'custom-merge-checks-activated',
  postOfficeInAppSwitcher: 'post-office-in-bitbucket-switcher',
  isNavThemeSelectorEnabled: 'enable-navigation-color-theme-picker',
  listOfAutoreviewCommentUuids: 'autoreview-comment-uuids',
} as const;

export type FeatureKeyType = (typeof FeatureKeys)[keyof typeof FeatureKeys];

export const pipelinesStatsigKeys = {
  inlineStopButtonEnabled: 'bitbucket_pipelines_pipelines_list_action_enabled',
  isPipelinesStepFilterEnabled: 'enable_pipelines_step_filter',
  isImprovedLogStreamingRenderingEnabled:
    'bitbucket_pipelines_improve_log_streaming_renders_',
  isPipelinesNavigationDropdownEnabled:
    'bitbucket_pipelines_navigation_dropdown_enabled',
  buildFixAiAssistantEnabled: 'bitbucket_pipelines_build_fix_ai_assistant',
  removeAllowanceSagaEnabled: 'bitbucket_pipelines_remove_allowance_saga',
  enableStashCommitLink: 'pipelines-add-stash-commit-link',
  isPipelinesManualStepsInStagesEnabled:
    'bitbucket-pipelines-allow-manual-steps-in-stages',
  isStepMetricsEnabled: 'bitbucket-pipelines-step-metrics-enabled',
  isPipelineListSidebarEnabled:
    'bitbucket-pipelines-pipeline-list-sidebar-enabled',
  isPipelineRunsHistoryEnabled:
    'bitbucket-pipelines-enable-pipeline-runs-history',
  updatedStepList: 'bitbucket-pipelines-updated-pipelines-step-list',
  showShadowRepositoryConfiguration:
    'bitbucket-pipelines-show-shadow-repo-configuration',
  removePrevLogCommandEnabled: 'bitbucket_pipelines_remove_prev_log_command',
  enablePersistPipelineListFilters:
    'bitbucket-pipelines-persist-pipeline-list-filters',
  isPipelinesMacOSTartRunnerEnabled: 'pipelines-mac-os-tart-runner',
  deprecatedRunnersWarningEnabled: 'pipelines_deprecated_runners_warning',
  pipelinesArtifactPreviewSizeLimit: 'pipelines-artifact-preview-size-limit',
  pipelinesMaximumAllowedStepSizeForCloudRunners:
    'pipelines-max-allowed-step-size-for-cloud-runners',
};

export const StatsigFeatureKeys = {
  ...pipelinesStatsigKeys,
  mergeStatusStateMessageDisabled: 'bbc-merge-status-state-message-disabled',
  prCreateDeleteBranchDefault: 'bbc-frontbucket-default-delete-branch',
  enableAutoreviewFeedbackUi: 'enable_autoreview_feedback_ui',
  disableFileEditForNonWriters: 'disable-file-edit-for-non-writers',
  gpgKeysUi: 'gpg-key-user-interface',
  postOfficeIntegrationInAppSwitcher:
    'post-office-integration-in-bitbucket-switcher',
  bbcToolbarHelpEditorApi: 'bbc-toolbarhelp-editorapi',
  disableCompassBitbucketRepositoryCard:
    'disable-compass-bitbucket-repository-card-statsig',
  bbcDraftPRs: 'bbc_draft_prs',
  activityFeedCommentsPreventReorder: 'activity_feed_comments_prevent_reorder',
  nextUnreviewedFile: 'bbc-frontbucket-next-unreviewed-file',
  webinarFlagEnabled: 'bbc-webinar-flag',
  markAllFiles: 'bbc-frontbucket-mark-all-files',
  descriptivePrUpdateFlag: 'descriptive_pr_update_flag',
  staleBranchesFilter: 'stale-branch-list-filter',
  mergeInProgressUxVisibility: 'merge-in-progress-ux-visibility',
  newSourceEditor: 'new-source-editor',
} as const;

export type StatsigFeatureKeyType =
  (typeof StatsigFeatureKeys)[keyof typeof StatsigFeatureKeys];
